import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class Support extends PureComponent {

    static propTypes = {
        content: PropTypes.array
    }

    render() {
        const { content } = this.props;

        return (
            <div>
                {
                    content.map((data, index) => {
                        return (
                            <div className={styles.logo} key={index}>
                                <a href={data.url} target="_blank" rel="noreferrer">
                                    <img src={data.image} alt="" />
                                </a>
                            </div>
                        );
                    })
                }
            </div>
        );
    }
}

export default Support;
